export default function TrustBanner() {
  return (
    <section style={{ backgroundColor: '#1E4F4F' }} className="py-12">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-0 divide-y md:divide-y-0 md:divide-x divide-[#2C6B6B]">
          {[
            { icon: 'ri-history-line', title: 'Trusted Since 1981', sub: '40+ years of magic' },
            { icon: 'ri-palette-line', title: 'Artist-Original Designs', sub: 'Copyrighted by individual artists' },
            { icon: 'ri-heart-line', title: 'Size Inclusive', sub: 'Regular & plus-size options' },
            { icon: 'ri-truck-line', title: 'Free Shipping', sub: 'On all orders $75+' },
          ].map((item) => (
            <div key={item.title} className="flex flex-col items-center text-center px-8 py-4 md:py-0 gap-2">
              <span className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-2xl`} style={{ color: '#E8B96A' }}></i>
              </span>
              <p style={{ fontFamily: '"Playfair Display", serif', color: '#FAF7F2', fontWeight: 700 }} className="text-base">
                {item.title}
              </p>
              <p style={{ fontFamily: '"Lato", sans-serif', color: '#A0C8C8' }} className="text-xs">
                {item.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
